module.exports = __webpack_public_path__ + "static/media/home_page_bottom_photo.8cc596bb.svg";